/** Message shape needed to decide if Sara still owes a reply. */
export type SaraLoadingMessage = {
  role?: string | null
  content?: unknown
  created_at?: string | null
}

/**
 * True when the latest Sara-store message is a user turn with text/files,
 * i.e. the thread looks like it is waiting for an assistant reply.
 */
export const lastSaraMessageAwaitsAssistant = (
  messages: SaraLoadingMessage[]
): boolean => {
  if (!messages.length) return false

  const sorted = [...messages].sort(
    (a, b) =>
      new Date(a.created_at ?? 0).getTime() -
      new Date(b.created_at ?? 0).getTime()
  )
  const last = sorted[sorted.length - 1]
  if (last.role !== 'user') return false

  let content: { message?: unknown; files?: unknown[] } = {}
  try {
    content =
      typeof last.content === 'string'
        ? JSON.parse(last.content || '{}')
        : ((last.content as { message?: unknown; files?: unknown[] }) ?? {})
  } catch {
    return false
  }

  return !!(content.message || content.files?.length)
}

/**
 * Thinking / stop UI should only run for an in-flight turn we started,
 * not for a historical orphaned user row left in the chat.
 */
export const computeSaraLoading = ({
  isMerchGptPending,
  expectingReply,
  lastAwaitsAssistant,
  giveUpWaiting,
}: {
  isMerchGptPending: boolean
  expectingReply: boolean
  lastAwaitsAssistant: boolean
  giveUpWaiting: boolean
}): boolean =>
  isMerchGptPending ||
  (expectingReply && lastAwaitsAssistant && !giveUpWaiting)
